import { NgxPermissionsModule } from 'ngx-permissions';
import { GoogleChartsModule } from 'angular-google-charts';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
	DxTemplateModule,
	DxButtonModule,
	DxDataGridModule,
	DxCheckBoxModule,
	DxSelectBoxModule,
	DxTreeListModule,
	DxFormModule,
	DxPopoverModule,
	DxPopupModule,
	DxPieChartModule,
	DxChartModule,
	DxTabPanelModule,
	DxGalleryModule
} from 'devextreme-angular';
import { MatDividerModule, MatInputModule, MatFormFieldModule, MatButtonModule, MatOptionModule, MatSelectModule, MatListModule, MatCheckboxModule, MatCardModule } from '@angular/material';
import { NgModule } from '@angular/core';
import { CommonModule, PercentPipe } from '@angular/common';

import { TableroRoutingModule } from './tablero-routing.module';
import { TableroComponent } from './tablero.component';
import { TablasComponent } from './components/tablas/tablas.component';
import { NgxChartsModule } from '@swimlane/ngx-charts';
@NgModule({
	declarations: [
		TableroComponent,
		TablasComponent],
	providers: [
		PercentPipe
	],
	imports: [
		CommonModule,
		TableroRoutingModule,
		MatDividerModule,
		DxTemplateModule,
		DxButtonModule,
		DxDataGridModule,
		DxCheckBoxModule,
		DxSelectBoxModule,
		DxTreeListModule,
		DxFormModule,
		DxPopoverModule,
		DxPopupModule,
		DxPieChartModule,
		DxChartModule,
		DxTabPanelModule,
		DxGalleryModule,
		FormsModule,
		MatInputModule,
		MatFormFieldModule,
		ReactiveFormsModule,
		MatButtonModule,
		MatOptionModule,
		MatSelectModule,
		MatListModule,
		MatCardModule,
		MatSlideToggleModule,
		GoogleChartsModule.forRoot(),
		NgxPermissionsModule,
		MatCheckboxModule,
		NgxChartsModule,
		
	],
	exports: [
		FormsModule,
		ReactiveFormsModule
	],
	//schemas: [ NO_ERRORS_SCHEMA ]
})
export class TableroModule { }
